<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <repse-request-table
            :data="data"
            @back="back"
            @loadMore="loadMore"
            @search="search"
            @refresh="getData"
            :title="title"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>
    
  <script>
import RepseRequestTable from './components/RepseRequestTable.vue'
import vendor from '@/http/requests/vendor/index.js'
export default {
  components: {
    RepseRequestTable,
  },
  data() {
    return {
      data: [],
      item: {},
      documentation: {
        id:'',
        document_name:'',
        vendor_name:''
      },
      lastPage: 1,
      loadingPage: 'repse-requests-loading',
      params: {
        search: '',
        page: 1,
      },
    }
  },
  computed:{
    title:function(){
      return this.$store.state.documentTitle
    }
  },  
  methods: {
  
    back:function(){
      this.$router.push('/repse/documentation')
    },
    getData: function () {
      let documentation_id = this.$route.fullPath
      this.$vs.loading()
      vendor
        .getRepseRequests(documentation_id.substr(30))
        .then((response) => {
          this.data = response.data.data
           this.$vs.loading.close()
        })
        .catch((response) => {
          this.showValidationErrors(response)
          console.log(response)
           this.$vs.loading.close()
        })
    },
    loadMore: function () {
      return
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search: function (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    getDetails: function (id) {
      this.$vs.loading()
      vendor
        .getDocumentationDetails(id)
        .then((response) => {
          this.documentation = Object.assign({}, response.data.documentation)
           this.$vs.loading.close()
          this.getData()
        })
        .catch((response) => {
          this.showValidationErrors(response)
           this.$vs.loading.close()
        })
    },
    init: function () {
      const storageVendor = localStorage.getItem('vendor')
      let vendorActive = JSON.parse(storageVendor)
      let repseActive = vendorActive.repse_active

      if(repseActive == 1){
        this.getData()
      }else{
        this.$router.push('/pages/not-authorized')
      }
    }

  },
  mounted: function () {
    this.init()
  },
  watch: {
    isLoading: function (val) {
      if (val) {
        this.$vs.loading()
      } else {
         this.$vs.loading.close()
      }
    },
  },
}
</script>
    
    <style>
</style>s